__webpack_require__.p = "/asset-prefix-tinspire008/";